import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-delete-user-profile-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './delete-user-profile-modal.component.html',
  styleUrl: './delete-user-profile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteUserProfileModalComponent {
  isOpen = input<boolean>(false);

  confirm = output<void>();

  cancel = output<void>();

  protected onConfirm(): void {
    this.confirm.emit();
  }

  protected onCancel(): void {
    this.cancel.emit();
  }
}
